import api from "lib/api";

export const getEmailTemplateList = async (params) => {
    return await api.post("/v1/emailTemplate/getEmailTemplateList", params);
};

export const saveEmailTemplate = async (params) => {
    return await api.post("/v1/emailTemplate/saveEmailTemplate", params);
};

export const deleteEmailTemplate = async (params) => {
    return await api.post("/v1/emailTemplate/deleteEmailTemplate", params);
};